import { useState } from "react";
import { Api } from "../../common/Api";
import { Employee } from "../../store/domains/Employee";

export const useEmployees = () => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [roles, setRoles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = () => {
    setLoading(true);
    Api.employee
      .list()
      .then((res) => {
        setEmployees(res.data.employees);
        setRoles(res.data.authRoles);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const regionDirectors = employees.filter((x) => x.roles.includes("Regional Director"));
  const divisionDirectors = employees.filter((x) => x.roles.includes("Division Director"));

  return {
    employees,
    regionDirectors,
    divisionDirectors,
    roles,
    loading,
    refresh,
  };
};
